export default "__VITE_ASSET__DfetEZfT__"